import { useFormContext, ValidationItems } from '@kanda-libs/ks-component-ts';
import { useEnquiryContext } from 'pages/Enquiry/context';
import { useMemo } from 'react';
import { formatWorkTypesToOptions, WorkTypeOption } from 'utils';
import { EnquiryQuoteConfirmDetailsFormValues } from '../../useEnquiryQuoteConfirmDetailsForm';

export interface EnquiryWorkTypeHook {
  workTypeOptions: WorkTypeOption[];
  workTypeValidation: ValidationItems;
}

export default function useEnquiryWorkType(): EnquiryWorkTypeHook {
  const { workTypes } = useEnquiryContext();
  const { getValues } = useFormContext<EnquiryQuoteConfirmDetailsFormValues>();

  const workTypeOptions = useMemo(() => {
    if (!workTypes) return [];
    return formatWorkTypesToOptions(workTypes);
  }, [workTypes]);

  const workTypeValidation = useMemo(
    () => ({
      required: {
        value: true,
        message: 'Work type is required',
      },
      validate: {
        value: () => {
          const selectedWorkType = getValues('job_info.work_type');
          if (!workTypes) return true;
          return workTypes.includes(selectedWorkType);
        },
        message: 'Work type must be from current company work types',
      },
    }),
    [workTypes, getValues],
  );

  return {
    workTypeOptions,
    workTypeValidation,
  };
}
